$(document).ready(function() {
  $('.footer-block__heading').on('click', function() {
    $(this).closest('.footer-block').toggleClass('footer-block--menus');
  });

   $('.sizechart-link').click(function(e){
    e.preventDefault()
    $('.pdp-size-guide').addClass('active')
})
 $('.close-pop').click(function(){
    $('.pdp-size-guide').removeClass('active')
})
 $('.centm-table').click(function(){
    $('.centm-table').addClass('active')
    $('.centm-table-main').addClass('active')
    $('.inches-table').removeClass('active')

    $('.inches-table-main').removeClass('active')
  })
  $('.inches-table').click(function(){
    $('.inches-table').addClass('active')
    $('.centm-table').removeClass('active')

    $('.inches-table-main').addClass('active')
    $('.centm-table-main').removeClass('active')
  })
  // jQuery
$('.read-more-btn').on('click', function() {
  $('.collection-hero__description').addClass('onit');
  $(this).hide(); // Hides the button
});
$('.mobile-facets__close').on('click', function() {
  $('details.mobile-facets__disclosure').removeAttr('open'); // Remove 'open' attribute from all <details>
  $('body').removeClass('overflow-hidden-mobile'); // Remove class from body
});


  // Select the element to observe
const targetNode = document.querySelector('product-recommendations');

// Options for the observer (which mutations to observe)
const config = { attributes: true, attributeFilter: ['class'] };

// Callback function to execute when mutations are observed
const callback = function(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      console.log('The class attribute was modified:', mutation.target.classList);
      // Perform actions based on the class change
var $slider = $('.related-product-slider');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
  
  $slider.slick({
    slidesToShow: 4.2,
    slidesToScroll: 1,
    infinite: false,
    speed: 400,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.3,
            slidesToScroll: 1
          }
        }
      ]
  });  
      
    }
  }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
  observer.observe(targetNode, config);

// To stop observing
// observer.disconnect();

  
});
